import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { PixelCodeComponent } from '@pixel/components/pixel-code/pixel-code.component';

@Component({
    selector: 'pixel-popup',
    templateUrl: './pixel-popup.component.html',
    styleUrls: ['./pixel-popup.component.scss'],
    standalone: true,
    imports: [MatButtonModule, PixelCodeComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PixelPopupComponent {
    public title = input<string>('Dodaj skrypt Ad & Pixel');

    public subtitle = input<string>('aby zintegrować reklamy z Twoim serwisem');

    public info = input<string>('Konto zostało aktywowane');
}
